import FormField from "../form-field";

export default class RadioField extends FormField {
    constructor(props = {}) {
        super(props);

        this.$radioButtons = null;
    }

    get $radioButtonElements() {
        if (!this.$radioButtons) {
            this.$radioButtons = this.$input.querySelectorAll('input[type="radio"]');
        }

        return this.$radioButtons;
    }

    _initElements() {
        super._initElements();
        this.$radioButtons = this.$input.querySelectorAll('input[type="radio"]');

        if (!this.$radioButtons.length) {
            throw new Error('RadioField: Radio buttons not found!');
        }
    }

    _afterInit() {
        this.$radioButtonElements.forEach(($radio) => {
            $radio.addEventListener('change', this._handleChange.bind(this));
        });

        const $checkedRadio = Array.from(this.$radioButtonElements).find(($radio) => $radio.checked);

        if ($checkedRadio && !this.controller.getValue()) {
            this._setChecked($checkedRadio.value);
        } else {
            this._refresh();
        }
    }

    _handleChange(e) {
        this.controller.setValue(e.target.value);
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _setChecked(value) {
        const $radio = Array.from(this.$radioButtonElements).find(($radio) => $radio.value === value);

        if (!$radio) {
            return;
        }

        $radio.checked = true;
        $radio.dispatchEvent(new Event('change'));
    }

    _setCheckedFirst() {
        this._setChecked(this.$radioButtonElements[0].value);
    }

    _setAllUnchecked() {
        const $radio = Array.from(this.$radioButtonElements).find(($radio) => $radio.checked);

        if (!$radio) {
            return;
        }

        $radio.checked = false;
        $radio.removeAttribute('checked');
        $radio.dispatchEvent(new Event('change'));
    }

    _refresh() {
        const value = this.controller.getValue();

        if (value) {
            this._setChecked(value);
        } else {
            this._setCheckedFirst();
        }
    }
}